var React = require('react');

function IconWindowsDesktop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM20 4L4 4V20H20V4Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7 11.6191V8.44273L10.8467 7.88773V11.6195L7 11.6191ZM7 12.3782V15.4918L10.8467 16.0718V12.3782H7ZM11.6159 12.3782V16.1882L17 17V12.3782H11.6159ZM17 11.6191V7L11.6159 7.77682V11.6191H17Z","fill":"currentColor","key":1})]);
}

IconWindowsDesktop.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconWindowsDesktop;

IconWindowsDesktop.default = IconWindowsDesktop;
